import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

type User = {
  email: string
  password: string
}

const ForcePassword = ({
  open,
  setOpen,
  user,
}: {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  user: User
}) => {
  const { t } = useTranslation()

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open}>
      <DialogTitle>{t('auth.changePassword.set_new')}</DialogTitle>
      <DialogContent>
      <Typography color="text.secondary" sx={{ pb: 2 }} variant="body2">
          {t('auth.changePassword.text')}
        </Typography>
      <Typography color="text.secondary" sx={{ pb: 2 }} variant="body2">
          {t('auth.changePassword.message', { email: user.email })}
        </Typography>
 
      </DialogContent>
      <DialogActions>
        <Button color="primary" fullWidth onClick={handleClose} variant="contained">
          {t('auth.changePassword.understood')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ForcePassword
